@if (cardComponentData) {
  <div class="card">
    <div class="card__image">
      <img
        [src]="getImageSrc(cardComponentData.image?.url)"
        loading="lazy"
        [alt]="cardComponentData.imageAltText"
      />
    </div>
    <div
      class="card__content"
      [class.card__content--no-gradient]="
        !(cardComponentData.backgroundGradient | safeCheck)
      "
    >
      <div class="card__text-wrapper">
        <h5 class="card__title">{{ cardComponentData.title }}</h5>
        <p class="card__text">{{ cardComponentData.subtitle }}</p>
      </div>
      <boels-generic-link-wrapper
        role="button"
        class="card__link link"
        [componentData]="cardComponentData"
      >
      </boels-generic-link-wrapper>
    </div>
  </div>
}
